import {Component, DoCheck, AfterViewChecked, AfterContentInit, OnInit} from '@angular/core';
import {DataLayer} from './data-layer';
import {DataLayerService} from './data-layer.service';
import {ForecastService} from './forecast.service';
import {StationData} from './station-data';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';

// declare all javascript variables/functions defined elsewhere
declare var $;

@Component({
	selector: 'station-table-component',
	templateUrl: 'station-table.component.html',
	styleUrls: ['station-table.component.css']
})
export class StationTableComponent implements DoCheck, AfterViewChecked, AfterContentInit, OnInit {
	dataLayerService: DataLayerService;
	forecastService: ForecastService;
	public stationsArray: any[] = [];
	weatherInfo = {};
	dataTypeDescription: string;
	station_id: any;
	station_name: any;
	numStations: string;
	currentDate: Date;
	novaScores: any[] = [];
	alarmTriggers: any[] = [];
	dialogVisible = false;
	forecastHeader: string;
	stationsObservable;
	sortByPreference: any[] = [];
	cols: any[];

	// set the following based on the screen size
	scrollHeight = '800px';

	sortType = 'rain';
	caret = 'fa fa-fw fa-caret-down';

	// once data types are more dynamic, sortTypeList should be dynamically created
	sortTypeList: any[] = [
		{label: 'Rain', value: 'rain'},
		{label: 'Water Level', value: 'waterLevel'},
		{label: 'Streamflow', value: 'streamflow'},
		{label: 'Wind', value: 'wind'}];


	constructor(dataLayerService: DataLayerService, forecastService: ForecastService) {
		this.dataLayerService = dataLayerService;
		this.forecastService = forecastService;
		this.attachEvents();

		if ( screen.height <= 400 ) {
			this.scrollHeight = '';
		}

		// const self = this;
		console.log('in station-table constructor');

	}

	// Currently, all stations are displayed.
	// The data type is appended to the station name.
	ngOnInit() {
		this.dataLayerService.parseAllStations().then(allStations => {
			this.readData();

			const dataLayer = this.dataLayerService.getDataLayerDetails ( 'allStations' );
			// self.stationsObservable = dataLayer.valueObservable.asObservable();
			// self.stationsObservable.subscribe ( stations => {
			this.stationsObservable = dataLayer.valueObserver.subscribe ( stations => {
				console.log('STATION READ FROM OBSERVABLE!!!');
				this.createTableFromStationDataLayer(dataLayer);
			});
			// console.log ( dataLayer );
		});
		this.setStickyCSS();

		this.cols = [
			{ field: 'id' },
			{ field: 'name' }
		];

	}

	readData() {

		this.dataTypeDescription =
			'Values shown are:\n   Rain (total for interval),\n   ' +
			'Water Level (maximum for interval),\n   Streamflow (maximum for interval),\n   Wind (maximum for interval)';

		// set up forecast data
		this.forecastService.readForecast()
			.subscribe ((forecast) => {
				// console.log(forecast);
				this.forecastService.setForecast(forecast);
				const next6Hours = this.forecastService.getNext6HoursForecast();
				console.log(next6Hours);
				const nextDay = this.forecastService.getNextDayForecast();
				const nextWeek = this.forecastService.getNextWeekForecast();
				const providerURL = this.forecastService.getProviderURL();

				this.weatherInfo['next6Hours'] = next6Hours['icon'];
				this.weatherInfo['next6HoursPrecipProbability'] = next6Hours['precipProbability'];
				this.weatherInfo['next6HoursMsg'] = next6Hours['summary'];
				this.weatherInfo['nextDay'] = nextDay['icon'];
				this.weatherInfo['nextDayPrecipProbability'] = nextDay['precipProbability'];
				this.weatherInfo['nextDayMsg'] = nextDay['summary'];
				this.weatherInfo['nextWeek'] = nextWeek['icon'];
				this.weatherInfo['nextWeekPrecipProbability'] = nextWeek['precipProbability'];
				this.weatherInfo['nextWeekMsg'] = nextWeek['summary'];
				this.weatherInfo['providerURL'] = providerURL;
		});

		this.forecastService.readObservedWeatherData()
			.subscribe ({ next: observed => {
				this.forecastService.setObservedWeatherData(observed);

				const observed15Minutes = this.forecastService.getObserved15Minutes();
				this.weatherInfo['last15Minutes'] = observed15Minutes['icon'];
				this.weatherInfo['last15MinutesMsg'] = observed15Minutes['summary'];

				const observedHour = this.forecastService.getObservedHour();
				this.weatherInfo['lastHour'] = observedHour['icon'];
				this.weatherInfo['lastHourMsg'] = observedHour['summary'];

				const observed3Hours = this.forecastService.getObserved3Hours();
				this.weatherInfo['last3Hours'] = observed3Hours['icon'];
				this.weatherInfo['last3HoursMsg'] = observed3Hours['summary'];

				const observedDay = this.forecastService.getObservedDay();
				this.weatherInfo['lastDay'] = observedDay['icon'];
				this.weatherInfo['lastDayMsg'] = observedDay['summary'];

				const observedWeek = this.forecastService.getObservedWeek();
				this.weatherInfo['lastWeek'] = observedWeek['icon'];
				this.weatherInfo['lastWeekMsg'] = observedWeek['summary'];
				}
			});


		const dataLayer = this.dataLayerService.getDataLayerDetails('allStations');
		this.createTableFromStationDataLayer(dataLayer);
		this.sortByAlarm (-1);
	}

	createTableFromStationDataLayer(dataLayer) {
		const tmpStationsArray: any[] = [];

		// console.log ( dataLayer );
			this.station_id = dataLayer.stationID;
			this.station_name = dataLayer.stationName;
			this.novaScores = dataLayer.value.novaScores;
			this.alarmTriggers = dataLayer.value.alarmTriggers;
			// console.log(this.novaScores);

			dataLayer.value.stationSummaries.forEach(function(item) {

				let newStation: any;
				// want to create object like - lastWeek: {"weather": 0, "rain": 1, "waterLevel": "-", "streamflow": 3, "wind": 88}};
				const lastWeek = {};
				const lastDay = {};
				const last3Hours = {};
				const lastHour = {};
				const last15Minutes = {};
				const alarmStatus = {};
				const hasData = {};

				this.retrieveStationStatistics ( item, 'Precip', 'rain', 'Total', 2,
					lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );
				this.retrieveStationStatistics ( item, 'WaterLevelRiver', 'waterLevel', 'Max', 1,
					lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );
				this.retrieveStationStatistics ( item, 'DischargeRiver', 'streamflow', 'Max', 1,
					lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );
				this.retrieveStationStatistics ( item, 'WindSpeed', 'wind', 'Max', 1,
					lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );

				// console.log(alarmStatus);

				newStation = { id: item[this.station_id],
						name: item[this.station_name],
						meas_count: item[this.station_id],
						lastWeek: lastWeek,
						lastDay: lastDay,
						last3Hours: last3Hours,
						lastHour: lastHour,
						last15Minutes: last15Minutes,
						hasData: hasData,
						alarmStatus: alarmStatus };
				// console.log(newStation);
				tmpStationsArray.push(newStation);

			}, this);

			// now copy temporary array over to array displayed in the table
			this.stationsArray.length = 0;
			this.stationsArray = tmpStationsArray;
			this.sortStationsByPreference ( );

			// set number of stations being displayed
			this.numStations = '' + this.stationsArray.length;
			console.log ( this.numStations );
	}

	ngDoCheck() {
		// console.log("ngDoCheck");
		this.setStickyCSS ();
	}
	ngAfterContentInit() {
		// console.log("ngAfterContentInit");
		this.setStickyCSS ();
	}

	ngAfterViewChecked() {
		// console.log("ngAfterViewChecked");
		const width = $('#lastWeekColumn').width();
		$('.numbers').css('width', width);
	}

	attachEvents() {
		window.onresize = () => {
			this.setStickyCSS ();
		};
	}

	// Not using this ... but leaving for future reference
	// had the following line in the constructor:
	// this.windowHeight = ""+this.getHeight();
	getHeight() {
		return window.innerHeight;
	}

	// When a user selects to sort the table, their preference must be saved so when the data
	// updates, it is still sorted according to their most recent preference.
	// The first element of the preference array will the "Id", "Name", "Threat", "Alarm", or "DataType".
	// The second element will be the number of parameters that follow.
	// The remaining elments will be the other parameters to send to the sorting function.
	saveSortByPreference ( preferences: any[] ) {
		this.sortByPreference.length = 0;
		this.sortByPreference = preferences;
		console.log( preferences );
	}

	// Sorts the table according to the previously preference.
	sortStationsByPreference ( ) {
		if ( this.sortByPreference.length === 0 ) {
			return;
		}
		if ( this.sortByPreference[0] === 'Id' && this.sortByPreference.length === 2 ) {
			this.sortById ( this.sortByPreference[1] );
		} else if ( this.sortByPreference[0] === 'Name' && this.sortByPreference.length === 2 ) {
			this.sortByName ( this.sortByPreference[1] );
		} else if ( this.sortByPreference[0] === 'Threat' && this.sortByPreference.length === 1 ) {
			this.sortByThreat ( );
		} else if ( this.sortByPreference[0] === 'DataType' && this.sortByPreference.length === 4 ) {
			this.sortByDataType ( this.sortByPreference[1], this.sortByPreference[2], this.sortByPreference[3] );
		} else if ( this.sortByPreference[0] === 'Alarm' && this.sortByPreference.length === 2 ) {
			this.sortByAlarm ( this.sortByPreference[1] );
		}
	}

	sortById (order) {
		this.saveSortByPreference ( ['Id', order] );
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}
		this.stationsArray.sort(function(a, b) {
			const aId = a.id;
			const bId = b.id;
			if ( aId < bId ) { return return1; }  // return -1 for descending
			if ( aId > bId ) { return return2; }   // return 1 for descending
			// id must be same - shouldn't ever happen
			return 0;
		});
	}

	sortByName (order) {
		this.saveSortByPreference ( ['Name', order] );
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}
		this.stationsArray.sort(function(a, b) {
			const aName = a.name.toUpperCase();
			const bName = b.name.toUpperCase();
			if ( aName < bName ) { return return1; }
			if ( aName > bName ) { return return2; }
			// name must be same - shouldn't ever happen
			return 0;
		});
	}

	sortByAlarm (order) {
		this.saveSortByPreference ( ['Alarm', order] );
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}
		this.stationsArray.sort(function(a, b) {
			const aAlarm = a.alarmStatus.alarmsMessage.length;
			const bAlarm = b.alarmStatus.alarmsMessage.length;
			if ( aAlarm < bAlarm ) { return return1; }  // return -1 for descending
			if ( aAlarm > bAlarm ) { return return2; }   // return 1 for descending
			//
			return 0;
		});
	}

	sortByThreat () {
		this.saveSortByPreference ( ['Threat'] );
		// descending
		const return1 = 1;
		const return2 = -1;

		this.stationsArray.sort(function(a, b) {
			let aValue = a.alarmStatus.rainNovaScore;
			let bValue = b.alarmStatus.rainNovaScore;
			aValue = (aValue === '-' || aValue == null) ? -999 : Number(aValue);
			bValue = (bValue === '-' || bValue == null) ? -999 : Number(bValue);
			if ( aValue < bValue ) { return return1; }
			if ( aValue > bValue ) { return return2; }
			// they are the same
			return 0;
		});
	}

	newSortDataTypeSelected (sortType) {
		this.sortType = sortType;
		console.log(sortType);
	}

	sortByDataTypeHelper(interval, order) {
		this.sortByDataType(this.sortType, interval, order);
	}

	// dataType is the display data type:  "rain", "waterLevel", "streamflow", "wind"
	sortByDataType (dataType, interval, order) {
		this.saveSortByPreference ( ['DataType', dataType, interval, order] );
		$('#topHeader').css('cursor', 'wait' );

		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}

		this.stationsArray.sort(function(a, b) {
			let aValue = a[interval][dataType];
			let bValue = b[interval][dataType];
			aValue = (aValue === '-') ? -999 : Number(aValue);
			bValue = (bValue === '-') ? -999 : Number(bValue);
			if ( aValue < bValue ) { return return1; }
			if ( aValue > bValue ) { return return2; }
			// they are the same
			return 0;
		});

		$('#topHeader').css('cursor', 'default' );
	}

	/* Retrieve the time series data from our datafile.  This fills in data for each time interval for a particular dataType.
	** stationInfo is a single station json object
	** dataType refers to the dataType in the datafile
	** displayType refers to the datatype in the html
	** 		At some point, these could be made the same.  The value in making them different is if dataTypes in the data file change,
	** 		the html doesn't need to change.
	** 		currently the dataType/displayType combinations are:
	**			? - "weather"
	**			"PrecipAccum" - "rain"
	**			"WaterLevelRiver" - "waterLevel"
	**			"DischargeRiver" - "streamflow"  // no streamflow at this point?
	**			"WindSpeed" - "wind"
	**
	** lastWeek, lastDay, last3Hours, lastHour, last15Minutes are json objects in which to save time series information for dataType
	*/
	// getStatistic is a helper function to retrieveStationStatistics - return the statistic value for a particular data type and duration
	getStatistic ( statisticsArray, dataType, statisticType, precision, duration, whichStatistic ) {
		let statistic = '-';
		if ( statisticsArray != null ) {
			const value = statisticsArray.filter( ts =>
				ts.dataType === dataType && ts.duration.toUpperCase() === duration.toUpperCase() && ts.statisticType === statisticType );
			// console.log(value);
			if ( value != null && value.length > 0) {
				const statisticValue = value[0][whichStatistic];
				// console.log(statisticValue);
				if ( statisticValue != null ) {
					statistic = statisticValue.toFixed(precision); }
				// console.log(statistic);
			}
		}
		return statistic;
	}

	// Return the alarms array or an empty array if it doesn't exist for this station.
	getAlarms ( stationInfo ) {
		if ( stationInfo.hasOwnProperty ('alarms')) {
			return stationInfo.alarms;
		}

		return [];
	}

	// Create a message to indicate if this station is in an alarm status.
	// The alarms passed in belong to an individual station.
	createAlarmMessage ( alarms ) {
		let alarmMessage = '';
		try {
			if ( alarms.length > 0 ) {
				for ( let i = 0; i < alarms.length; i++ ) {
					// get the alarm name
					if ( alarms[i].alarmState === 'Active' ) {

						let alarmName = '';
						const alarmsArray = this.alarmTriggers.filter(function(stat) {
									return stat.id === alarms[i].triggerId; });
						if ( alarmsArray.length > 0 ) {
							alarmName = alarmsArray[0].name;
						}
						// create the alarm hover message
						alarmMessage += '' + alarms[i].alarmDateTime +
							'\nName: ' + alarmName +
							'\nTrigger value: ' + alarms[i].triggerValue + ' ' + alarms[i].triggerValueUnits +
							'\nMessage: ' + alarms[i].triggerMessage + '\n';
					}
				}
			}
		} catch (err) {
			console.log('Error processing alarm.');
		}
		return alarmMessage;
	}

	retrieveStationStatistics ( stationInfo, dataType, displayType, statisticType, precision,
			lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData ) {
		// set default values
		const lastWeekValue = this.getStatistic ( stationInfo.statistics, dataType, statisticType, precision, '7day', 'statisticValue');
		const lastDayValue = this.getStatistic ( stationInfo.statistics, dataType, statisticType, precision, '1day', 'statisticValue');
		const last3HoursValue = this.getStatistic ( stationInfo.statistics, dataType, statisticType, precision, '3hour', 'statisticValue');
		const lastHourValue = this.getStatistic ( stationInfo.statistics, dataType, statisticType, precision, '1hour', 'statisticValue');
		const last15MinutesValue = this.getStatistic ( stationInfo.statistics, dataType, statisticType, precision, '15minute', 'statisticValue');
		const alarmStatusValue = this.getStatistic ( stationInfo.statistics, dataType, statisticType, 0, '15minute', 'novaScore');
		const alarms = this.getAlarms ( stationInfo );

		/*
		const alarmClasses = { };
		if ( +alarmStatusValue === 3 ) {
			alarmClasses['warning'] = true;
		} else if ( +alarmStatusValue >= 4 ) {
			alarmClasses['alarm'] = true;
		}
		*/
		const novaScoreClassString = alarmStatusValue === '-' ? 'novaScore1' : 'novaScore' + alarmStatusValue;
		// console.log ( novaScoreClassString );

		// fill in values for dataType if any values were found
		lastWeek[displayType] = lastWeekValue;
		lastDay[displayType] = lastDayValue;
		last3Hours[displayType] = last3HoursValue;
		lastHour[displayType] = lastHourValue;
		last15Minutes[displayType] = last15MinutesValue;

		hasData[displayType] = (lastWeekValue === '-' && lastDayValue === '-' && last3HoursValue === '-' &&
			lastHourValue === '-' && last15MinutesValue === '-') ? false : true;

		alarmStatus[displayType + 'NovaScore'] = alarmStatusValue;
		alarmStatus[displayType + 'NovaScoreClass'] = novaScoreClassString;
		// alarmStatus[displayType + 'class'] = alarmClasses;
		alarmStatus[displayType] = this.translateToNovaScoreName(alarmStatusValue);
		// if ( alarms.length > 0 ) { console.log('Alarms: ', alarms); }
		alarmStatus['alarmsMessage'] = this.createAlarmMessage(alarms);
	}

	// helper function to retrieve retrieveStationStatistics
	// translates a numerical novaScore to the name
	translateToNovaScoreName ( novaScore: any ): string {
		// console.log(novaScore);
		if ( novaScore === '-' || novaScore === 0 ) { return novaScore; }

		const novaScores = this.novaScores.filter ( ns => {
			// this cannot be ===
			return ns.id == novaScore;
		});
		const name = novaScores[0].shortDisplayName;
		// console.log(name);
		return name;
	}

	setStickyCSS () {
		const topHeaderHeight = $('#topHeader').height();
		// console.log(topHeaderHeight);
		if ( topHeaderHeight < 400 ) {
			$('#tableBody').css('padding-top', topHeaderHeight );
		}
	}
}
